import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/components/Courses/CourseModal.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Courses/ScheduleModal.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Gallery/Gallery.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/HamburgerProvider/HamburgerProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Header/Header.tsx")